import { gql } from "@apollo/client";

export const CRAFTMAN = gql(`
    query Craftman(
      $where: UserWhereUniqueInput!  
    ) {
      user(where: $where) {
        id
        active
        dateOfLastConnexion
        isFavoris
        lastName
        name
        workshopName
        role
        description
        minQuantityOrder
        cuurentUserHaveStory
        country {
          name_fr
        }
        PhotoAchievements {
          id
          url
          name
        }
        ProfilePhoto {
          id
          url
          name
        }
        Categories {
          id
          name_en
          name_fr
        }
        ItemTypes {
          id
          name_en
          name_fr
        }
        MaterialTypes {
          id
          name_en
          name_fr
        }
        BannerPhoto {
          id
          url
        }
        UserStories {
          id
        }
        country {
          alpha2
        }
        _count {
          CraftmanFavorites
          CraftmanOrders
          NoticeOrders
        }
      }
    }
  `);

  export const CRAFTMAN_LAST_DATE_CONNEXION = gql(`
    query Craftman(
      $where: UserWhereUniqueInput!  
    ) {
      user(where: $where) {
        active
        dateOfLastConnexion
      }
    }
  `);
